import { AbiItem } from 'web3-utils';

const CHECK_TASK_NAME = 'checkTask';
const PERFORM_TASK_NAME = 'performTask';

export function isCompatibleAbi(abiItems: AbiItem[]): boolean {
  const isPerformAbi = abiItems.some(({ name }) => name === PERFORM_TASK_NAME);
  const isCheckAbi = abiItems.some(({ name }) => name === CHECK_TASK_NAME);

  return isPerformAbi && isCheckAbi;
}
